import type React from 'react';

import type { FaceId } from '@vlabs/api/luna-api/model';
import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { CircleAnimatedButton } from '@vlabs/uikit';
import type { CircleAnimatedButtonProps } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToFaceDetailsTranslation } from './i18n';
import type { GoToFaceDetailsProps } from './types';
import { buildTestid } from '../../shared/lib/utils';

interface GoToFaceDetailsCircleAnimatedButtonProps extends GoToFaceDetailsProps, Omit<CircleAnimatedButtonProps, 'children' | 'icon'> {
  faceId: FaceId;
}

const displayName = 'GoToFaceDetailsCircleAnimatedButton';
const testid = buildTestid(displayName);

function GoToFaceDetailsCircleAnimatedButton({
  faceId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToFaceDetailsCircleAnimatedButtonProps): React.JSX.Element {
  const { t } = useGoToFaceDetailsTranslation();

  return (
    <CircleAnimatedButton
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      size="small"
      to={generatePath(routes.facePage, { faceId })}
      {...testid(dataTestId)}
      {...props}
    >
      {t('title')}
    </CircleAnimatedButton>
  );
}

GoToFaceDetailsCircleAnimatedButton.displayName = displayName;

export { GoToFaceDetailsCircleAnimatedButton };
